<template lang="pug">
aside-modal(id="settingSetForm", ref="modal", :loading="onLoading('save-set')")
    template(slot="header-text")
        | Create Settings Set
    template(slot="body")
        div.padding
            form(@submit.prevent="submit")
                fieldset
                    div.form-group
                        label Name
                        input.form-control(
                            type="text",
                            name="name",
                            v-validate="'required'",
                            v-model="set.name"
                        )
                        span.form-error-msg.text-danger(
                            v-show="errors.has('name')",
                        ) {{ errors.first('name') }}

    template(slot="footer")
        button.btn.btn-fw.primary(:disabled="!canManageSettings" @click="submit")
            v-loading(loader="save-set") Save
                            
</template>

<script>
import { mapActions } from 'vuex';
import validatorLaravelError from '../../../mixins/validator-laravel-error';
import event from './central-setting-event';
import PermissionMixin from '../settings-permission';

export default {
    mixins: [validatorLaravelError, PermissionMixin],

    data() {
        return {
            set: {
                name: null,
            },
        };
    },

    mounted() {
        this.$on('show', () => this.$refs.modal.$emit('show'));
    },

    methods: {
        ...mapActions('centralSettings', ['createSettingSet']),

        async submit() {
            const validated = await this.$validator.validate();

            if (!validated) {
                return;
            }

            this.startLoading('save-set');

            try {
                const { data } = await this.createSettingSet(this.set);

                this.$refs.modal.$emit('hide');
                this.name = null;
                this.showToastrSuccess();
                event.$emit('show-update-form', data);
                event.$emit('set-created');
            } catch (err_response) {
                this.processLaravelErrors(
                    this.$validator,
                    err_response.response,
                );
            }

            this.endLoading('save-set');
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/setting/central-settings/central-setting-set-form.vue